import { defineEvent } from '../types/event';
export var PRODUCT_CARD_CAROUSEL_ARROW_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            transform: function (input) { return ({
                eventName: 'image_carousel__arrow_click',
                direction: input.direction
            }); }
        },
        {
            name: 'Heap',
            transform: function (input) { return ({
                eventName: 'productCard_carouselArrow',
                productCard_title: input.title
            }); }
        }
    ]
});
